import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getTagInfo, updateTagInfo, getUserProfile } from "../services/api";
import { useSearchParams, useNavigate } from "react-router-dom";
import { convertFromISO } from "../utils/dateValidation";
import { PlusSquare } from "lucide-react";
import Cookies from "js-cookie";
import {
    Box,
    Button,
    Container,
    Stack,
    TextField,
    Typography,
    Alert,
    CircularProgress
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const QrVerification = () => {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { t, i18n: i18nInstance } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [loadingButton, setloadingButton] = useState(false);
    const [disableSubmit, setdisableSubmit] = useState(false);
    const tagId = searchParams.get('qr') || '';
    const [qrImagePreview, setqrImagePreview] = useState(null);
    const [petImagePreview, setPetImagePreview] = useState(null);
    const [tagInfo, setTagInfo] = useState({
        staffVerification: "",
        contact: "",
        verifyDate: "",
        petName: "",
        shortUrl: "",
        masterEmail: "",
        qrUrl: "",
        petUrl: "",
        orderId: "",
        location: "",
        petHuman: "",
        createdAt: "",
    });

    // Create a preview URL for the image
    const reader = new FileReader();
    reader.onloadend = () => {
        setqrImagePreview(reader.result);
    };

    // Create a preview URL for the image
    const reader2 = new FileReader();
    reader2.onloadend = () => {
        setPetImagePreview(reader2.result);
    };

    // Handle form field changes
    const handleInputChange = (field, value) => {
        setTagInfo((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // Get token from cookies
    const getUserId = () => {
        const id = Cookies.get("id");
        return id;
    };

    const SubmitTagData = async () => {
        try {
            setloadingButton(true);
            setError("");
            setSuccess("");

            tagInfo.staffVerification = true;
            tagInfo.verifyDate = convertFromISO(new Date());

            const response = await updateTagInfo(tagId, tagInfo);

            if (response.status === 200) {
                setSuccess(`${t('VerificationCompletedOn')} ${tagInfo.verifyDate}`);
                window.scrollTo({ top: 0, behavior: "auto" });
            } else {
                setError("Error updating Tag Info!!");
            }
        } catch (err) {
            console.error("Error updating tagInfo:", err);
            setError("Error updating Tag Info!!");
        } finally {
            setloadingButton(false);
            setdisableSubmit(true);
        }
    }



    // Fetch tag info
    const userId = getUserId();
    useEffect(() => {
        setLoading(true);
        setError("");
        if (!userId) {
            setError("No authentication token found. Please login again.");
            if (tagId) {
                setTimeout(() => {
                    navigate(`/login?qr=${tagId}`)
                }, 1000);
            }
            setLoading(false);
            return;
        }

        getUserProfile(userId)
            .then((response) => {
                const userRole = response.data.user.role;
                switch (userRole) {
                    case "user":
                        setError("Only Admin can access this page!");
                        setLoading(false);
                        break;
                    case "admin":
                        getTagInfo(tagId)
                            .then((response) => {
                                const tagData = response.data.form;
                                setTagInfo((prev) => ({
                                    ...prev,
                                    ...tagData,
                                    createdAt: convertFromISO(tagData.createdAt),
                                }));
                                if (tagData.petUrl) {
                                    setPetImagePreview(tagData.petUrl);
                                }
                                if (tagData.qrUrl) {
                                    setqrImagePreview(tagData.qrUrl);
                                }
                                setLoading(false);
                                if (tagData.staffVerification) {
                                    setSuccess(`${t('VerificationCompletedOn')} ${convertFromISO(tagData.verifyDate)}`);
                                    setdisableSubmit(true);
                                }
                            })
                            .catch((error) => {
                                console.error("Error fetching Tag Info:", error);
                            });
                    default:
                        return
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching User Role:", error);
            });
    }, [tagId, userId]);

    // Check and convert success message based on language
    useEffect(() => {
        if (success) {
            const currentLanguage = i18nInstance.language;
            
            // Check if language is Chinese or English and convert accordingly
            if (currentLanguage === 'zh') {
                // Convert to Chinese if not already
                if (success.includes('Verification Completed On')) {
                    const dateMatch = success.match(/Verification Completed On (.+)/);
                    if (dateMatch) {
                        setSuccess(`驗證完成於 ${dateMatch[1]}`);
                    }
                }
            } else if (currentLanguage === 'en') {
                // Convert to English if not already
                if (success.includes('驗證完成於')) {
                    const dateMatch = success.match(/驗證完成於 (.+)/);
                    if (dateMatch) {
                        setSuccess(`Verification Completed On ${dateMatch[1]}`);
                    }
                }
            }
        }
    }, [success, i18nInstance.language]);

    if (loading) {
        return (
            <Box
                sx={{
                    bgcolor: "#fcf8f3",
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        {/* 載入中... */}
                        <img src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif" alt=""
                            style={{
                                width: '150px',
                                height: 'auto',
                                mixBlendMode: 'multiply',
                            }} />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ bgcolor: "#fcf8f3", minHeight: "100vh" }}>
            {/* Header */}
            <Navbar />

            {/* Main Content */}
            <Container
                maxWidth="lg"
                sx={{
                    py: { xs: 4, md: 8 },
                    px: { xs: 2, md: 3 },
                    mt: "70px", // Add top margin to account for fixed navbar height
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        mb: { xs: 3, md: 5 },
                        fontWeight: "bold",
                        fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    }}
                >
                    {t('QrVerificationPage')}
                </Typography>

                {/* Error and Success Messages */}
                {error && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                        {error}
                    </Alert>
                )}
                {success && (
                    <Alert severity="success" sx={{ mb: 3 }}>
                        {success}
                    </Alert>
                )}

                <Stack
                    spacing={{ xs: 4, md: 6 }}
                    sx={{ maxWidth: { xs: "100%", sm: 400, md: 450 } }}
                >
                    <Stack spacing={{ xs: 2.5, md: 3 }}>
                        {/* Pet Name */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('petName')}:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Tom"
                                value={tagInfo.petName}
                                // onChange={(e) => handleInputChange("petHuman", e.target.value)}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Pet Contact */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                               {t('petContact')}:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={tagInfo.contact}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Pet Short Url */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('PetShortUrl')}:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={tagInfo.shortUrl}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Pet Tag Image */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                               {t('PetTagImage')}:
                            </Typography>
                            <Box
                                sx={{
                                    border: 1,
                                    borderColor: "grey.300",
                                    borderRadius: 1,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 350,
                                    backgroundColor: "white",
                                    position: "relative",
                                }}
                            >
                                {qrImagePreview ? (
                                    <img
                                        src={qrImagePreview}
                                        alt="預覽圖片"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 250,
                                            marginBottom: 16,
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <PlusSquare size={48} />
                                )}
                            </Box>
                        </Box>

                        <Typography
                            variant="h4"
                            sx={{
                                mb: { xs: 3, md: 5 },
                                fontWeight: "bold",
                                fontSize: { xs: "24px", sm: "28px", md: "32px" },
                            }}
                        >
                            {t('deliveryInfo')}
                        </Typography>

                        {/* Owner Name */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('OwnerName')}:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="Alex"
                                variant="outlined"
                                value={tagInfo.petHuman}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Pet Image */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('PetImage')}:
                            </Typography>
                            <Box
                                sx={{
                                    border: 1,
                                    borderColor: "grey.300",
                                    borderRadius: 1,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 350,
                                    backgroundColor: "white",
                                    position: "relative",
                                }}
                            >
                                {petImagePreview ? (
                                    <img
                                        src={petImagePreview}
                                        alt="預覽圖片"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 250,
                                            marginBottom: 16,
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <PlusSquare size={48} />
                                )}
                            </Box>
                        </Box>

                        {/* Address Delivery */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('address')}:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="22 Cornwall Street, Kowloon Tong, Hong Kong"
                                variant="outlined"
                                value={tagInfo.location}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Order Number */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('OrderNumber')}
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="CUS-XXXXXXXXX"
                                variant="outlined"
                                value={tagInfo.orderId}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Owner Email: */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('OwnerEmail')}:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="abcd@gmail.com"
                                variant="outlined"
                                value={tagInfo.masterEmail}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Tag Id */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('TagId')}:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="XXXXXX"
                                variant="outlined"
                                value={tagInfo.tagId}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                        {/* Tag creattion date */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                {t('TagCreationDate')}
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder="DD/MM/YYYY"
                                variant="outlined"
                                value={tagInfo.createdAt}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>

                    </Stack>
                    <Stack spacing={{ xs: 1.5, md: 2 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                mb: { xs: 0.5, md: 1 },
                                fontSize: { xs: "10px", md: "12px" },
                                fontWeight: "600",
                                color: 'red',
                            }}
                        >
                            {t('BeforeSubmit')}
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={SubmitTagData}
                            disabled={disableSubmit}
                            sx={{
                                backgroundColor: "#FFB60C",
                                color: "#050505",
                                minWidth: 120,
                                "&:hover": { backgroundColor: "#FFB60C" },
                                "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                                cursor: loadingButton ? "not-allowed" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "10px",
                            }}
                        >
                            {t('Submit')}
                            {loadingButton && (
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <CircularProgress size={15} color="inherit" />
                                </span>
                            )}
                        </Button>
                    </Stack>
                </Stack>
            </Container>

            <Footer />
        </Box>
    );
};

export default QrVerification;
